import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Container } from "react-bootstrap";
import Annotations from "../Component/Annotations";
import { FaCaretUp } from "react-icons/fa";
import Speedometer from "../Component/Speedometer";
import Tablelisting from "../Component/Tablelisting";
import {
  getCategory,
  getCmsData,
  getCoins,
  getNetwork,
} from "../Actions/v1/user";
import { useSelector } from "react-redux";
import { formatNumber } from "../Actions/commonFunction";
import { socket } from "../Hooks/Socket";
import config from "../config/config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

let coinlistinstance = [];
function Home() {
  const [categorylist, setCategorylist] = useState([]);
  const [selCat, setSelCat] = useState({ id: "all", name: "all" });
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [networklist, setNetworkList] = useState([]);
  const [selNetwork, setSelNetwork] = useState({ id: "all", name: "all" });
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [searchtext, setSearchtext] = useState("");
  const [coinlist, setCoinlist] = useState([]);
  const { headerData } = useSelector((state) => state.user);
  const [announcementList, setAnnouncementList] = useState([]);
  const [selSubCat, setSelSubCat] = useState({ id: "all", name: "all" });
  console.log("🚀 ~ Home ~ headerDatas:", headerData);

  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    margin:10,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          //   initialSlide: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //Get Category
  const getCategorylist = async () => {
    let resp = await getCategory();
    console.log("🚀 ~ getCategorylist ~ resp:", resp);
    if (resp?.status) {
      setCategorylist(resp.data);
    }
  };

  const getNetworklist = async () => {
    let resp = await getNetwork();
    if (resp?.status) {
      setNetworkList(resp.data);
    }
  };
  console.log("selNetwork-->", selNetwork);
  //getCoinList
  const getCoinlist = async (data) => {
    let resp = await getCoins({
      page: currentPage,
      limit,
      catId: selCat?.id,
      network: selNetwork?.id,
      subcat : selSubCat?.id,
      min,
      max,
      searchtext,
    });
    if (resp?.status) {
      if (data == "page" && currentPage > 0) {
        setCoinlist([...coinlist, resp.data]);
        coinlistinstance = [...coinlist, resp.data];
      } else {
        setCoinlist(resp.data);
        coinlistinstance = resp?.data;
      }
    }
  };

  const getCms = async () => {
    let resp = await getCmsData({ slug: "announcement" });
    console.log("🚀 ~ getCms ~ resp:", resp);
    if (resp?.status) {
      setAnnouncementList(resp?.data);
    }
  };

  useEffect(() => {
    getCoinlist();
  }, [selCat, searchtext]);

  useState(() => {
    getCoinlist("page");
  }, [currentPage]);

  useEffect(() => {
    getNetworklist();
    getCategorylist();
    getCms();
  }, []);

  useEffect(() => {
    socket.on("pricechangearray", (data) => {
      console.log("🚀 ~ socket.on ~ pricechangearray:", data);
      let allcoinlist = coinlistinstance;
      let index = allcoinlist.findIndex((coin) => coin.tokenId == data?.coin);
      console.log("🚀 ~ socket.on ~ index:", index);
      allcoinlist[index] = { ...allcoinlist[index], ...data };
      console.log("🚀 ~ socket.on ~ allcoinlist:", allcoinlist);
      setCoinlist(allcoinlist);
    });
  }, [socket]);

  return (
    <div>
      <div>
        <Header />

        <div className="inner_page">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-4">

            <Slider {...settings}>
            <div>
            <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.market} alt="market" />
                  <h5 className="mb-0">Market Cap</h5>
                </div>
                <div className="d-flex gap-1 justify-content-between align-items-center mt-4">
                  <div>
                    <h4 className="mb-0 dash_h">
                      $
                      {formatNumber(
                        headerData?.dominance?.total_marketCap ?? 0
                      )}
                    </h4>
                    <div className="caret mt-1">
                      {" "}
                      <FaCaretUp />
                      <span>7.08%</span>
                    </div>
                  </div>
                  <img
                    src={Images.dashgraph}
                    className="img-fluid"
                    alt="graph"
                  />
                </div>
              </div>
            </div>

            <div>
                    <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.volume} alt="volume" />
                  <h5 className="mb-0">Volume</h5>
                </div>
                <div className="d-flex gap-3 justify-content-between align-items-center mt-4">
                  <div>
                    <h4 className="mb-0 dash_h">
                      ${formatNumber(headerData?.dominance?.total_volume ?? 0)}
                    </h4>
                    <div className="caret mt-1">
                      {" "}
                      <FaCaretUp />
                      <span>7.08%</span>
                    </div>
                  </div>
                  {/* <Annotations /> */}
                  <img
                    src={Images.dashgraph}
                    className="img-fluid"
                    alt="graph"
                  />
                </div>
              </div>
            </div>

            <div>
            <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.feargreed} alt="feargreed" />
                  <h5 className="mb-0">Fear&Greed</h5>
                </div>
                <div className="d-flex gap-1 align-items-center speed_mt">
                  <Speedometer />
                </div>
              </div>
            </div>

            <div>
            <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <img src={Images.dominance} alt="dominance" />
                  <h5 className="mb-0">Dominance</h5>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <img src={Images.bnb} className="coin" alt="bnb" />{" "}
                  <h5 className="mb-0 domi_per dash_h">
                    {formatNumber(
                      headerData?.dominance?.Dominence?.find(
                        (val) => val.symbol == "BTC"
                      )?.dominance ?? "0"
                    )}
                    %
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2 mt-3">
                  <img src={Images.eth} className="coin" alt="eth" />{" "}
                  <h5 className="mb-0 domi_per dash_h">
                    {formatNumber(
                      headerData?.dominance?.Dominence?.find(
                        (val) => val.symbol == "ETH"
                      )?.dominance ?? "0"
                    )}
                    %
                  </h5>
                </div>
              </div>
            </div>
            {announcementList?.map((val) => (
             <div>
        
                <div className="dash_card anno_card px-3 py-3">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <img
                      src={config.Back_URL + "cms/" + val.images}
                      className="announce_img"
                      alt="announcement"
                    />
                    <h5 className="mb-0">{val.title}</h5>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        val.content.length > 170
                          ? `${val.content?.slice(0, 200)}...`
                          : val?.content,
                    }}
                  />
                </div>
              
             </div>
             ))}

            </Slider>
           

            {/* dashlist */}
            {/* <div className="dashlist d-flex flexdashlist gap-2">
              <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.market} alt="market" />
                  <h5 className="mb-0">Market Cap</h5>
                </div>
                <div className="d-flex gap-1 justify-content-between align-items-center mt-4">
                  <div>
                    <h4 className="mb-0 dash_h">
                      $
                      {formatNumber(
                        headerData?.dominance?.total_marketCap ?? 0
                      )}
                    </h4>
                    <div className="caret mt-1">
                      {" "}
                      <FaCaretUp />
                      <span>7.08%</span>
                    </div>
                  </div>
                  <img
                    src={Images.dashgraph}
                    className="img-fluid"
                    alt="graph"
                  />
                </div>
              </div>

              <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.volume} alt="volume" />
                  <h5 className="mb-0">Volume</h5>
                </div>
                <div className="d-flex gap-3 justify-content-between align-items-center mt-4">
                  <div>
                    <h4 className="mb-0 dash_h">
                      ${formatNumber(headerData?.dominance?.total_volume ?? 0)}
                    </h4>
                    <div className="caret mt-1">
                      {" "}
                      <FaCaretUp />
                      <span>7.08%</span>
                    </div>
                  </div>
                  <img
                    src={Images.dashgraph}
                    className="img-fluid"
                    alt="graph"
                  />
                </div>
              </div>

              <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2">
                  <img src={Images.feargreed} alt="feargreed" />
                  <h5 className="mb-0">Fear&Greed</h5>
                </div>
                <div className="d-flex gap-1 align-items-center speed_mt">
                  <Speedometer />
                </div>
              </div>

              <div className="dash_card px-3 py-3">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <img src={Images.dominance} alt="dominance" />
                  <h5 className="mb-0">Dominance</h5>
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <img src={Images.bnb} className="coin" alt="bnb" />{" "}
                  <h5 className="mb-0 domi_per dash_h">
                    {formatNumber(
                      headerData?.dominance?.Dominence?.find(
                        (val) => val.symbol == "BTC"
                      )?.dominance ?? "0"
                    )}
                    %
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2 mt-3">
                  <img src={Images.eth} className="coin" alt="eth" />{" "}
                  <h5 className="mb-0 domi_per dash_h">
                    {formatNumber(
                      headerData?.dominance?.Dominence?.find(
                        (val) => val.symbol == "ETH"
                      )?.dominance ?? "0"
                    )}
                    %
                  </h5>
                </div>
              </div>

              {announcementList?.map((val) => (
                <div className="dash_card anno_card px-3 py-3">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <img
                      src={config.Back_URL + "cms/" + val.images}
                      className="announce_img"
                      alt="announcement"
                    />
                    <h5 className="mb-0">{val.title}</h5>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        val.content.length > 170
                          ? `${val.content?.slice(0, 200)}...`
                          : val?.content,
                    }}
                  />
                </div>
              ))}
           
            </div> */}
            {/* dashlist end */}

            <Tablelisting
              setSelSubCat={setSelSubCat}
              selSubCat={selSubCat}
              data={coinlist}
              itemsPerPage={10}
              categoryList={categorylist}
              setSelCat={(data) => setSelCat(data)}
              selCat={selCat}
              setCurrentPage={(page) => setCurrentPage(page)}
              currentPage={currentPage}
              networklist={networklist}
              selNetwork={selNetwork}
              setSelNetwork={(data) => setSelNetwork(data)}
              min={min}
              setMin={(data) => setMin(data)}
              max={max}
              setMax={(data) => setMax(data)}
              getCoinlist={getCoinlist}
              searchtext={searchtext}
              setSearchtext={(data) => setSearchtext(data)}
            />
          </Container>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default Home;
